module.exports = __webpack_public_path__ + "static/award-filebuzz-786b5e9fcefdcc54e674e5722c69b799.png";